import React,{Component} from 'react';
import styles from './index.scss'

class Index extends Component{
    render(){
        return(
            <div className={styles['loading-wrapper']}>

            </div>
        )
    }
}


export default Index
